export const FaqDetailPublish2 = () => {
    return (
        <>
            <div className="content_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">자주 묻는 질문 상세보기</h3>
                    <div className="filter_toolbar">
                        <button className="btn btn-outline-primary w-100px h-38px"><img src={process.env.PUBLIC_URL + "/assets/images/icon_hamburger_btn.png"} alt="" />목록</button>
                        <button className="btn btn-secondary w-100px h-38px">수정</button>
                    </div>
                </div>
                <div className="table_scroll mb-0">
                    <table className="table table-bordered my_table table_detailx">
                        <tbody>
                            <tr>
                                <th colSpan={2} style={{ width: "12.5%" }}>제목</th>
                                <td className="p-4px">
                                    <input type="text" className="form-control" value={"오프라인 전화 인증은 어떻게 하나요?"} />
                                </td>
                            </tr>
                            <tr>
                                <th colSpan={2}>작성자/등록일</th>
                                <td>김철수 | 2024-00-00</td>
                            </tr>
                            <tr>
                                <th rowSpan={4}>기본정보</th>
                                <th style={{ width: "6.5%" }}>유형</th>
                                <td className="p-4px">
                                    <select className="form-select w-150px">
                                        <option>설치</option>
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <th>벤더</th>
                                <td className="p-4px">
                                    <select className="form-select w-150px">
                                        <option>MS</option>
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <th>카테고리</th>
                                <td className="p-4px">
                                    <select className="form-select w-150px">
                                        <option>Win11</option>
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <th>구분</th>
                                <td className="p-4px">
                                    <select className="form-select w-150px">
                                        <option>공지</option>
                                    </select>
                                </td>
                            </tr>
                            <tr style={{ height: "249px" }}>
                                <th colSpan={2}>내용</th>
                                <td className="p-4px" style={{ verticalAlign: "top" }}>
                                    <textarea className="form-control" rows={10}></textarea>
                                </td>
                            </tr>
                            <tr>
                                <th colSpan={2}>첨부파일</th>
                                <td className="p-4px">
                                    <div className="tbl_files_outer">
                                        <ul className="list_files">
                                            <li>
                                                <a href="#/file-1">첨부파일1.pdf</a>
                                                <button className="btn btn-link p-0"><img src={process.env.PUBLIC_URL + "/assets/images/icon_deltoken.png"} alt="" /></button>
                                            </li>
                                            <li>
                                                <a href="#/file-1">첨부파일2.pdf</a>
                                                <button className="btn btn-link p-0"><img src={process.env.PUBLIC_URL + "/assets/images/icon_deltoken.png"} alt="" /></button>
                                            </li>
                                            <li>
                                                <a href="#/file-1">첨부파일3.pdf</a>
                                                <button className="btn btn-link p-0"><img src={process.env.PUBLIC_URL + "/assets/images/icon_deltoken.png"} alt="" /></button>
                                            </li>
                                        </ul>
                                        <button className="btn btn-outline-secondary">파일 업로드</button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}